// Sets url hash when specific popup is opened. E.g. property photos.
stimulusApp.register(
  "set-hash",
  class extends Stimulus.Controller {
    static outlets = ["popup-modal"]
    static values = {
      hash: String,
    }
    lastHash = null

    connect() {
      const hash = `#${this.hashValue}`
      this.lastHash = hash
      if (location.hash !== hash) {
        window.HB.hashNav.setHash(this.hashValue)
      }
      window.addEventListener("hashchange", this.#handleHash)
    }

    disconnect() {
      window.removeEventListener("hashchange", this.#handleHash)
      if (location.hash === `#${this.hashValue}`) {
        window.HB.hashNav.backOrSetHash("")
      }
    }

    #handleHash = () => {
      // Close popup if hash changed from hashValue to anything else
      const hashChange = this.lastHash !== location.hash
      if (this.lastHash === `#${this.hashValue}` && hashChange) {
        this.popupModalOutlet?.close()
      }
      this.lastHash = location.hash
    }
  },
)
